import { twMerge } from 'tailwind-merge';

const breakpoints = {
  xs: 375,
  sm: 480,
  'sm-md': 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export { breakpoints, twMerge };
